// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".contrast .tabs[data-v-351ae598]{background-color:#000!important}.contrast .tabs .tab a.active[data-v-351ae598],.contrast .tabs .tab a[data-v-351ae598]:hover{background-color:#fff!important;color:#000!important}.contrast .tabs .indicator[data-v-351ae598]{border:1px solid #fff}", ""]);
// Exports
module.exports = exports;
